/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import { checkPermissions } from '../routeValidation';
import { NavigationGuardNext, Route } from 'vue-router';
import { transactionHistoryMonitorPermissions } from './permissions/index';

const TransactionsTicketsMonitor = () =>
  import(
    /* webpackChunkName: "transastion_ticket_monitor" */
    '@/views/TransactionsTickets/Statistic/Index.vue'
  );

const transactionsTicketsPages = {
  path: '/',
  component: DashboardLayout,
  name: 'TransactionsTickets',
  children: [
    {
      path: '/transactions-statistics',
      name: 'transactionsTicketsMonitor',
      component: TransactionsTicketsMonitor,
      beforeEnter(
        to: Route,
        from: Route,
        next: NavigationGuardNext<Vue>
      ): void {
        checkPermissions(to, from, next, transactionHistoryMonitorPermissions);
      },
      meta: {
        navbarType: 'light',
      },
    },
    {
      path: '/payments',
      name: 'transactionsPayins',
      component: () => import('@/views/TransactionsTickets/PaymentsReport/index.vue'),
      beforeEnter(
        to: Route,
        from: Route,
        next: NavigationGuardNext<Vue>
      ): void {
        checkPermissions(to, from, next, transactionHistoryMonitorPermissions);
      },
      meta: {
        navbarType: 'light',
      },
    }
  ],
};
export default transactionsTicketsPages;
